document.addEventListener('DOMContentLoaded', () => {
            const carousels = document.querySelectorAll('.quote-carousel');
            
            carousels.forEach(carousel => {
                const track = carousel.querySelector('.carousel-track') as HTMLElement | null;
                const prevButton = carousel.querySelector('.prev-btn') as HTMLButtonElement | null;
                const nextButton = carousel.querySelector('.next-btn') as HTMLButtonElement | null;
                const controls = carousel.querySelector('.carousel-controls');
                
                const quotes = carousel.querySelectorAll('.slide');

                let currentIndex = 0;

                function updateCarousel() {
                    if (!track) return;
                    const firstSlide = track.querySelector('.slide');
                    if (firstSlide) {
                         const slideWidth = firstSlide.clientWidth;
                         track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
                    }

                    Array.from(quotes).forEach((slide, idx) => {
                        const isActive = idx === currentIndex;
                        slide.setAttribute('aria-hidden', String(!isActive));

                        const interactiveSelector = 'a, button, input, textarea, select, [tabindex]';
                        const interactives = Array.from(slide.querySelectorAll<HTMLElement>(interactiveSelector));

                        interactives.forEach(el => {
                            if (isActive) {
                                const originalTabindex = el.getAttribute('data-orig-tabindex');
                                if (originalTabindex !== null) {
                                    if (originalTabindex) {
                                        el.setAttribute('tabindex', originalTabindex);
                                    } else {
                                        el.removeAttribute('tabindex');
                                    }
                                    el.removeAttribute('data-orig-tabindex');
                                }
                            } else {
                                if (el.getAttribute('data-orig-tabindex') === null) {
                                    el.setAttribute('data-orig-tabindex', el.getAttribute('tabindex') || '');
                                }
                                el.setAttribute('tabindex', '-1');
                            }
                        });
                    });

                    if (prevButton) {
                        prevButton.disabled = currentIndex === 0;
                        prevButton.setAttribute('aria-disabled', String(prevButton.disabled));
                    }
                    if (nextButton) {
                        nextButton.disabled = currentIndex === quotes.length - 1;
                        nextButton.setAttribute('aria-disabled', String(nextButton.disabled));
                    }
                }
                
                if (quotes.length <= 1 && controls) {
                    (controls as HTMLElement).style.display = 'none';
                }

                if (nextButton) {
                    nextButton.addEventListener('click', () => {
                        if (currentIndex < quotes.length - 1) {
                            currentIndex++;
                            updateCarousel();
                        }
                    });
                }

                if (prevButton) {
                    prevButton.addEventListener('click', () => {
                        if (currentIndex > 0) {
                            currentIndex--;
                            updateCarousel();
                        }
                    });
                }

                let touchstartX = 0;
                let touchendX = 0;

                carousel.addEventListener('touchstart', (e: Event) => {
                    const touchEvent = e as TouchEvent;
                    touchstartX = touchEvent.changedTouches[0].screenX;
                }, { passive: true });

                carousel.addEventListener('touchend', (e: Event) => {
                    const touchEvent = e as TouchEvent;
                    touchendX = touchEvent.changedTouches[0].screenX;
                    handleSwipe();
                });

                function handleSwipe() {
                    if (touchendX < touchstartX) {
                        nextButton && nextButton.click();
                    }
                    if (touchendX > touchstartX) {
                        prevButton && prevButton.click();
                    }
                }

                updateCarousel();

                window.addEventListener('resize', updateCarousel);
            });
        });